// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3s1yJ","title":"BackImages_title__9t09W","images":"BackImages_images__3M8Zq"};